<template>
  <div>
    <!-- HERO -->
    <HeroCourse
      class="relative z-10"
      :data="page"
      @scroll-to-course-dates="onScrollToCourseDates()"
      @resize="onResize($event)"
    />

    <!-- CONTENT SIDEBAR -->
    <div ref="elContentSidebar" class="pointer-events-none">
      <div class="relative grid-cols-4 xl:grid xl:pr-container-desktop-wide">
        <div ref="elContentSidebarContent" class="col-span-3">
          <div class="pointer-events-auto relative mt-5 sm:-mt-8">
            <ComponentsLoader
              v-editor-target="'course_replicator_components_sidebar'"
              :components="page.course_replicator_components_sidebar"
            />
          </div>
        </div>
        <!-- DESKTOP -->
        <AnimatedContainer>
          <CourseSidebar
            class="fade-in pointer-events-auto z-20 col-span-1 hidden xl:block"
            :page="page"
            :has-course-dates="page.course_dates?.length > 0"
            @scroll-to-course-dates="onScrollToCourseDates()"
          />
        </AnimatedContainer>
      </div>
    </div>

    <!-- CONTENT -->
    <div>
      <!-- COURSE DATES -->
      <div v-if="page.course_dates?.length" ref="elCourseDates">
        <CourseDates
          :heading="page.course_dates_heading"
          :course-dates="page.course_dates"
        />
      </div>

      <!-- NO COURSE DATES -->
      <ContentSection v-else>
        <Container indent="wide">
          <h2 class="max-w-title text-2xl font-medium">
            {{ $t('currently_no_courses') }}
          </h2>
        </Container>
      </ContentSection>

      <Container indent="wide">
        <SocialShareIcons :alternates="page.alternates" class="mb-16" />
      </Container>

      <ComponentsLoader
        v-editor-target="'course_replicator_components'"
        :components="page.course_replicator_components"
      />
    </div>
  </div>
</template>

<script setup>
provide('isCourse', true)

defineProps({
  page: { type: Object, required: true },
})

const elContentSidebar = ref(null)
const elContentSidebarContent = ref(null)
const elCourseDates = ref(null)

const isSidebarReady = ref(false)

// FUNCTIONS
function onResize(height) {
  isSidebarReady.value = true
  if (!elContentSidebar.value) {
    return
  }

  elContentSidebarContent.value.style.paddingTop = height + 'px'
  elContentSidebar.value.style.marginTop = -height + 'px'
}

function onScrollToCourseDates() {
  if (!elCourseDates.value) {
    return
  }

  const headerOffset = 80
  const elementPosition = elCourseDates.value.offsetTop
  const offsetPosition = elementPosition - headerOffset

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  })
}
</script>
